import { Stack, Paper, Box, Group, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconTrash } from '@tabler/icons-react';
import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import { Outlet, useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import ForceResultModal from '../../components/force-result-modal/force-result-modal';
import FormInfo from '../../components/form-info/form-info';
import { intercultureApi } from '../../data-access/apis/interculture';
import { intercultureQueries } from '../../data-access/queries/interculture';

import classes from './page.module.css';

import { useAuth } from '@auth/data-access';
import {
  FORM_STATUS,
  hasAdminAccess,
  useQueriesWithGlobal,
} from '@data-access';
import {
  ActionsMenuItem,
  FullMainHeight,
  FieldHeader,
  TsrButtonLink,
} from '@ui';

export function IntercultureResultsPage() {
  const { t } = useTranslation();
  const { formId, crop } = useParams({
    from: '/_app/interculture_/$crop/$formId/result',
  });
  const { user } = useAuth();
  const [opened, { open, close }] = useDisclosure(false);

  const forceResult = useMutation({
    mutationFn: intercultureApi.createForcedResult,
  });

  const queries = useQueriesWithGlobal(intercultureQueries);
  const { data } = useSuspenseQuery(
    queries.result({
      id: Number(formId),
      crop,
    }),
  );

  const handleSubmitResult = (values: {
    status: FORM_STATUS;
    comment: string;
  }) => {
    forceResult.mutate({
      form: data.id,
      comment: values.comment,
      forced_status: values.status,
    });
    close();
  };

  const menuActions: ActionsMenuItem[] = [
    {
      type: 'action',
      label: 'Supprimer',
      color: 'red',
      icon: IconTrash,
      props: {
        disabled: true,
      },
      onClick: () => null,
    },
  ];

  return (
    <FullMainHeight.Root>
      <FullMainHeight.FlexContent>
        <FullMainHeight.Sidebar size="lg">
          <Stack className={classes.navCol}>
            <Paper className={classes.navHeader}>
              <FieldHeader fieldId={data.field.id.toString()} />
            </Paper>
            <Paper className={classes.navBar} p={0}>
              <Stack gap={0} h="100%" justify="space-between">
                <Box>
                  <FormInfo form={data} />
                </Box>
                <Group p="md" wrap="nowrap">
                  {hasAdminAccess(user?.user_access) ? (
                    <Button onClick={open}>Forcer le résultat</Button>
                  ) : null}
                  <TsrButtonLink color="red" to="/interculture">
                    {t('common.back')}
                  </TsrButtonLink>
                </Group>
              </Stack>
            </Paper>
          </Stack>
        </FullMainHeight.Sidebar>

        <Outlet />
        <ForceResultModal
          close={close}
          defaultValidationStatus={data?.status || FORM_STATUS.UNDEFINED}
          forcedResult={data?.forced_result}
          onSubmit={handleSubmitResult}
          opened={opened}
        />
      </FullMainHeight.FlexContent>
    </FullMainHeight.Root>
  );
}

export default IntercultureResultsPage;
